import React, { useContext, useState } from "react";
import AppContext from "../../../context/store";
import { Grid, Column } from "../../../theme/Grid";
import AuthContainer from "../../../components/AuthContainer";
import Button from "../../../theme/Button";
import Axios from "axios";
import { toast } from "react-toastify";
import SalonKariyer from "../../../assets/images/svg/salon-kariyer-tam.svg";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Card, CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  card: {
    maxWidth: 400,
    textAlign: "center",
    border: "none !important",
    padding: theme.spacing(4),
  },
  icon: {
    width: "50%",
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  description: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },
  button: {
    marginTop: theme.spacing(2),
  },
}));

const SalonKariyerLogin = () => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const handleSalonKariyerLogin = async () => {
    setLoading(true);

    try {
      const response = await Axios.post(`${context.api_endpoint}/company/auth-link/salon-kariyer`, {});

      if (response.status === 201) {
        const { mail, token } = response.data;
        const tokenStringfy = JSON.stringify(token);
        const salonKariyerUrl = `https://kariyersalon.com/oauth/authorize?request_id=` + tokenStringfy.replaceAll('"', '');

        window.open(salonKariyerUrl, '_blank', 'noopener,noreferrer');
      }
    } catch (error) {
      console.error('Salon Kariyer login error:', error);

      if (error.response?.status === 3009) {
        toast.error('Salon Kariyer entegrasyonu için özel durum. Lütfen tekrar deneyin.');
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Salon Kariyer giriş işlemi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <Grid>
        <Column className="xs-12 sm-12 md-12 lg-12">
          <div className={classes.container}>
            <div className={classes.card}>
              <img src={SalonKariyer} alt="Salon Kariyer" className={classes.icon} />
              <Typography variant="h5" className={classes.title}>
                Salon Kariyer'e Giriş
              </Typography>
              <Typography variant="body1" className={classes.description}>
                Salon Kariyer uygulamasına güvenli bir şekilde giriş yapmak için aşağıdaki butona tıklayın.
              </Typography>
              <Button
                title={loading ? "Giriş yapılıyor..." : "Salon Kariyer'e Giriş Yap"}
                size="lg"
                fullWidth
                textColor="white"
                backgroundColor="primary"
                onClick={handleSalonKariyerLogin}
                disabled={loading}
                className={classes.button}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              />
            </div>
          </div>
        </Column>
      </Grid>
    </AuthContainer>
  );
};

export default SalonKariyerLogin;

